import React from "react";
import { Link } from "react-router-dom";
import Icon from "@/components/ui/Icon";
import styles from "./styles.module.scss";

interface PageHeaderBack {
  label: string;
  to?: string;
  state?: unknown;
  // Voltar sem trocar de rota (ex.: sair do editor de temas).
  onClick?: () => void;
}

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  // Selo ao lado do título (ex.: "Bloqueado no seu plano").
  badge?: React.ReactNode;
  back?: PageHeaderBack;
  actions?: React.ReactNode;
}

// Cabeçalho padrão das páginas do painel: título + descrição de uma linha à
// esquerda e ações (período, atualizar) à direita, sempre com a mesma altura.
// O "voltar" fica na linha do título para não criar uma linha extra.
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, badge, back, actions }) => (
  <header className={styles.header}>
    <div className={styles.text}>
      <h1 className={styles.title}>
        {back &&
          (back.to ? (
            <Link to={back.to} state={back.state} className={styles.back} aria-label={back.label} title={back.label}>
              <Icon name="chevronLeft" size={18} strokeWidth={2.4} />
            </Link>
          ) : (
            <button type="button" onClick={back.onClick} className={styles.back} aria-label={back.label} title={back.label}>
              <Icon name="chevronLeft" size={18} strokeWidth={2.4} />
            </button>
          ))}
        <span className={styles.titleText}>{title}</span>
        {badge}
      </h1>
      {description && (
        <p className={styles.description} title={typeof description === "string" ? description : undefined}>
          {description}
        </p>
      )}
    </div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </header>
);

export default PageHeader;
